import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { getUserData } from '../_actions';
import {
  checkFeatures,
  checkFeatureToggles,
  checkPerms,
  getFirstEntry,
  hasContractorRole,
  isContractor,
  isLovesClient,
  sideBarShow
} from '../helpers/utils';
import { clearLocalStorage } from '../helpers/localStorage';

const ProtectedRoute = ({ component, path, visible, exact, name, detail, feature }) => {
  const user = getUserData();
  const param = window.location.pathname;
  if (visible === 'protected' && !user.logged_in) return <Redirect to={`/login?q=${param}`} />;
  if (path.includes('reset-password')) {
    clearLocalStorage();
    return <Route exact={exact} path={path} component={component} />;
  }
  if (visible === 'unauthorized' && user.logged_in)
    return <Redirect to={{ pathname: getFirstEntry() }} />;
  if (path === '/facility_list' && checkFeatures('facility_profile.read')) {
    return <Route exact={exact} path={path} component={component} />;
  }
  if (name === 'forms_mapper') {
    return checkFeatures(feature) ? (
      <Route exact={exact} path={path} component={component} />
    ) : (
      <Redirect to={{ pathname: '/404' }} />
    );
  }
  if (name === 'regulatory_inspections' && sideBarShow('regulatory_inspections_enabled')) {
    return <Route exact={exact} path={path} component={component} />;
  }
  if (name === 'quick_dispatch_enabled' && sideBarShow(name) && checkFeatures(feature)) {
    return <Route exact={exact} path={path} component={component} />;
  }
  if (
    name === 'regulatory_action_tracking_details' &&
    checkFeatureToggles('regulatory_inspections_enabled')
  ) {
    return <Route exact={exact} path={path} component={component} />;
  }
  if (name === 'permits') {
    return <Route exact={exact} path={path} component={component} />;
  }
  if (name === 'permit_details' && checkFeatureToggles('permit_tracking_enabled')) {
    return <Route exact={exact} path={path} component={component} />;
  }
  if (name === 'quick_dispatch_enabled') {
    return <Redirect to={{ pathname: '/404' }} />;
  }
  if (!checkPerms(name, user)) {
    return <Redirect to={{ pathname: '/404' }} />;
  }
  if (name === 'workorders_enabled' && detail && isContractor()) {
    return <Redirect to={{ pathname: '/404' }} />;
  }
  if (path === '/workorders' && hasContractorRole(user)) {
    return <Redirect to={{ pathname: '/assigned_deficiencies' }} />;
  }
  if (name === 'workorders_enabled' && !sideBarShow(name, path)) {
    return <Redirect to={{ pathname: '/404' }} />;
  }
  if (name === 'test_tracking_enabled' && !sideBarShow(name)) {
    return <Redirect to={{ pathname: '/404' }} />;
  }
  if (name === 'inventory_management_enabled' && !checkFeatureToggles(name)) {
    return <Redirect to={{ pathname: '/404' }} />;
  }
  if (name === 'release_detection_enabled' && !checkFeatureToggles(name)) {
    return <Redirect to={{ pathname: '/404' }} />;
  }
  if (path === '/setup_center' && checkFeatures(feature) && isLovesClient()) {
    return <Redirect to={{ pathname: '/404' }} />;
  }
  if (feature && !checkFeatures(feature)) {
    return <Redirect to={{ pathname: '/404' }} />;
  }
  return <Route exact={exact} path={path} component={component} />;
};

ProtectedRoute.propTypes = {
  // component: PropTypes.func.isRequired,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  path: PropTypes.string.isRequired,
  visible: PropTypes.string.isRequired,
  exact: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  detail: PropTypes.bool,
  feature: PropTypes.string
};

ProtectedRoute.defaultProps = {
  component: () => {},
  detail: false,
  feature: ''
};

export default ProtectedRoute;
